import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { compose, withState, withHandlers, nest, lifecycle } from 'recompose';

import { isRtl } from 'modules/language/selectors/language';
import { showProfileBox } from '../../actions/showProfileBox';

import AccountDetails from './AccountDetails';
import AccountDetailsHint from '../AccountDetailsHint';

const mapStateToProps = () => ({
  rtl: isRtl(),
});

export default compose(
  connect(mapStateToProps, { showProfileBox }),
  injectIntl,

  withState('isTooltipShowed', 'setTooltipState', false),

  withHandlers({
    handleTooltipClick: () => (event) => event.stopPropagation(),
    handleLayoutClick: ({ setTooltipState }) => () => setTooltipState(false),

    handleIconClick: ({ setTooltipState, isTooltipShowed, showProfileBox }) => () => {
      if (!isTooltipShowed) {
        showProfileBox();
      }

      setTooltipState(!isTooltipShowed);
    },

    handleKeyClick: ({ setTooltipState, isTooltipShowed }) => (e) => {
      if ((e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27) && isTooltipShowed) {
        setTooltipState(!isTooltipShowed);
      }
    },

  }),

  lifecycle({
    componentDidMount() {
      window.addEventListener('click', this.props.handleLayoutClick);
      window.addEventListener('keydown', this.props.handleKeyClick);
    },

    componentWillUnmount() {
      window.removeEventListener('click', this.props.handleLayoutClick);
      window.removeEventListener('keydown', this.props.handleKeyClick);
    },
  }),
)(nest(AccountDetailsHint, AccountDetails));
